/**
 * @generated SignedSource<<c1240f21547de2742ed98bb1738e9793>>
 * @relayHash b6d092ac62b5c43f31e4b164c044058e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ed0d251d1e4b99e177b175d1efcc76779a6fc750213e2a245189de018e51a2ec

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type IssueAppSelectorModalProjectTypeQuery$variables = {
  cloudId: string;
  includeAgenticWorkItemData: boolean;
  issueKey: string;
};
export type IssueAppSelectorModalProjectTypeQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly projectField: {
        readonly project: {
          readonly isAgenticWorkItemViewEnabled?: boolean | null;
          readonly isCreatedFromAgenticTemplate?: boolean | null;
          readonly projectType: JiraProjectType | null;
        } | null;
      } | null;
    } | null;
    readonly userPreferences: {
      readonly isIssueViewWivEnabled: boolean | null;
    } | null;
  } | null;
};
export type IssueAppSelectorModalProjectTypeQuery = {
  response: IssueAppSelectorModalProjectTypeQuery$data;
  variables: IssueAppSelectorModalProjectTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAgenticWorkItemData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v6 = {
  "condition": "includeAgenticWorkItemData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCreatedFromAgenticTemplate"
    },
    {
      "kind": "ScalarField",
      "name": "isAgenticWorkItemViewEnabled"
    }
  ]
},
v7 = {
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "JiraUserPreferences",
  "kind": "LinkedField",
  "name": "userPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isIssueViewWivEnabled"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueAppSelectorModalProjectTypeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueAppSelectorModalProjectTypeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              (v8/*: any*/)
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "ed0d251d1e4b99e177b175d1efcc76779a6fc750213e2a245189de018e51a2ec",
    "metadata": {},
    "name": "IssueAppSelectorModalProjectTypeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "409226f0291e2a736bcc2d1bb49dff35";

export default node;
